@if (component) {
<div class="text"
     *iCms="'text' of component; content 'html'"></div>
}
